// extracted by mini-css-extract-plugin
export default {"tooltip":"OD0Zx","children":"tbAkN","green":"yT1F5","yellow":"U4Hgt","gray":"OV2i6","violet":"znHxB"};